import React from 'react';
import { Tooltip } from '@material-ui/core';
import { Sync } from '@material-ui/icons';

const RepeatIcon = ({
	value,
	onClick = () => false,
	tooltip = 'Revertir',
	disabled,
	color = 'success',
	className = '',
}) => {
	return (
		<Tooltip title={tooltip}>
			<span>
				<button
					onClick={onClick}
					disabled={disabled}
					style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
					className={`btn btn-icon btn-sm btn-${
						disabled ? 'light' : color
					} ${className}`}
				>
					<span className={`svg-icon svg-icon-md`}>
						<Sync />
					</span>
				</button>
			</span>
		</Tooltip>
	);
};

export default RepeatIcon;
